import {Injectable} from "@angular/core";
import {Size} from "../types";
import {loadImage} from "../helper";

interface LoadImageArgs {
  url?: string;
  base64?: string;
  resizeTo?: Size
}

@Injectable({providedIn: 'root'})
export class ImageCache {
  private log = false;
  private cache = new Map<string, { image: HTMLImageElement; lastUsed: Date, loaded: Date }>();

  async get(args: LoadImageArgs): Promise<HTMLImageElement> {

    const key = this.getKey(args);

    // Check if the image is cached and valid
    const cached = this.cache.get(key);
    if (cached) {
      if (this.log) console.log('ImageCache: Using cached image ✅');
      cached.lastUsed = new Date();
      return cached.image;
    }

    if (this.log) console.log('ImageCache: Loading image 🚨');

    const image = await loadImage(args);
    this.cache.set(key, { image, lastUsed: new Date(), loaded: new Date() });

    return image
  }

  private getKey(args: LoadImageArgs): string {
    const resizeTo = args.resizeTo ? `${args.resizeTo.width}x${args.resizeTo.height}` : '';
    if (args.url) {
      return `${args.url}${resizeTo}`;
    }
    return `${args.base64}${resizeTo}`;
  }

  public clear(){
    for (const [key, value] of this.cache) {
      value.image.src = '';
      value.image.remove();
    }
    this.cache.clear();
  }
}
